import { DiscardOrSaveChanges } from "./DiscardOrSaveChanges.js";

export default DiscardOrSaveChanges;
